import React from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import Adal from '../adal/adal-request';
import MainNavHeader from './MainNavHeader';
// eslint-disable-next-line no-unused-vars
import styles from './header.scss';


class Header extends React.Component {
  onLangSelect(lng) {
    const {actions} = this.props;
    actions.setLocale(lng);
  }

  doLogout(e) {
    Adal.logOut();
  }

  render() {
    const {authInfo} = this.props;
    const {intl} = this.props;
    const {locale} = this.props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({id: message}, data);
    };
    return (
      <div>
        <div className="container brand-bar">
          <img src="/images/logo.gif" />
          <img src="/images/logo_ideamgmt_jpeg.jpg" />
          <div className="pull-right brand-links-container">
            <ul className="top-right-nav-bar">
              {authInfo.IsAdmin &&
                <li><Link to="/initiative-types">{t('Initiative Types')}</Link></li>
                  }
              <li><a href="https://dcah.wdm.wartsila.com/Default.aspx?#E8B4D7D6-09EA-4F54-B555-8B7F39944DAB/object/C44EAF5F-9717-4BF2-9600-1D0985BB4947/latest">{t('Rules')}</a></li>
              <li className="btn-container"><button type="button" className="btn btn-link" onClick={this.doLogout}>{authInfo.DisplayName} <i className="glyphicon glyphicon-log-out"/></button></li>
              <li className="btn-container">
                <Dropdown id="lang-select-cb" onSelect={this.onLangSelect.bind(this)}>
                  <Dropdown.Toggle>
                    <img src={`/images/${locale}.png`} alt="locale"/>&nbsp;{t(`LOCALE_${locale}`)}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <MenuItem eventKey="fi"><img src="/images/fi.png" alt="fi"/>&nbsp;SUOMI-FI</MenuItem>
                    <MenuItem eventKey="en"><img src="/images/en.png" alt="en"/>&nbsp;ENGLISH-EN</MenuItem>
                    <MenuItem eventKey="sv"><img src="/images/sv.png" alt="sv"/>&nbsp;SVENSKA-SV</MenuItem>
                  </Dropdown.Menu>
                </Dropdown>
              </li>
            </ul>
            <h3 id="slogan">{t('CONTINUOUS IMPROVEMENT')}</h3>
          </div>
        </div>
        <MainNavHeader authInfo={this.props.authInfo}/>
      </div>
    );
  }
}

Header.displayName = 'Header';
Header.propTypes = {};
Header.defaultProps = {

};

export default injectIntl(Header);



// WEBPACK FOOTER //
// ./components/Header.js